import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';

class LoadPlacementTestItemService {
  fetch = new FetchService();
  constructor() {
    extendObservable(this, {
      placementTestItem: null,
    });
  }

  handleLoad = action(async (placementTestId, itemId) => {
    const { item, grammarPlacementTestLevel } = await this.fetch.fetch({
      url: `/grammar-placement-test-levels/${placementTestId}/items/${itemId}`,
    });
    const placementTestLevel = await this.fetch.fetch({
      url: `/placement-test-levels/${grammarPlacementTestLevel.placementTestLevel}`,
    });
    this.placementTestItem = {
      item,
      grammarPlacementTestLevel: {
        ...grammarPlacementTestLevel,
        placementTestLevel,
      },
    };
  });
}

export default LoadPlacementTestItemService;
